"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const Export = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 12,
  viewBox: "0 0 16 12",
  fill: "none"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.25 0v4.777H12L8 9.855 4 4.777h2.75V.007a4.92 4.92 0 00-1.84.917 5.04 5.04 0 00-1.635 2.218 1.325 1.325 0 01-.76.753c-.661.26-1.215.688-1.66 1.285A4.241 4.241 0 000 7.786c0 1.138.391 2.1 1.173 2.888.782.787 1.724 1.18 2.827 1.18h8.727a3.11 3.11 0 002.319-.983c.636-.657.954-1.454.954-2.391 0-.863-.276-1.616-.827-2.26a3.181 3.181 0 00-1.224-.898c-.47-.19-.847-.6-.922-1.102a5.07 5.07 0 00-1.418-2.837C10.925.678 10.139.217 9.25 0z",
  className: "fill"
}));

var _default = Export;
exports.default = _default;